// extracted by mini-css-extract-plugin
module.exports = {"Number":"NotFound_Number__2GjDy","Text":"NotFound_Text__1XKnt","SubText":"NotFound_SubText__2LrLc","Reactangle":"NotFound_Reactangle__1VqqN"};